import { render, staticRenderFns } from "./NovoModeloDocumento.vue?vue&type=template&id=309232ad"
import script from "./NovoModeloDocumento.vue?vue&type=script&lang=js"
export * from "./NovoModeloDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports